// extracted by mini-css-extract-plugin
export default {"container":"style_container__axYg1","lds-spinner":"style_lds-spinner__Btzs4"};